import { render } from "./GamesContent.vue?vue&type=template&id=ffecb838"
import script from "./GamesContent.vue?vue&type=script&lang=ts"
export * from "./GamesContent.vue?vue&type=script&lang=ts"
script.render = render

export default script